const broadcastContentEnums = {
  TRACKER_LINK: 'https://github.com/virtuevise/vv-tracker-setup/releases',
  // VERSION: '2.0.1',
}
module.exports = { broadcastContentEnums }
